import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-percent"]
const _hoisted_2 = { class: "ppc-progress" }
const _hoisted_3 = { class: "ppc-percents" }
const _hoisted_4 = { class: "pcc-percents-wrapper" }
const _hoisted_5 = { class: "ppc-percents-content" }
const _hoisted_6 = { class: "font-bold sold-percentage" }

import { toRefs } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeaderCircle',
  props: {
    soldPercentage: {}
  },
  setup(__props: any) {

const props = __props;
const { soldPercentage } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (!isNaN(_unref(soldPercentage)) && _unref(soldPercentage) >= 60)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["progress-pie-chart", [_unref(soldPercentage) > 50 ? 'gt-50' : '']]),
        "data-percent": _unref(soldPercentage)
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "ppc-progress-fill",
            style: _normalizeStyle({ transform: `rotate(${(360 * _unref(soldPercentage)) / 100}deg)` })
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(soldPercentage)) + "%", 1),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-semibold d-block sold-text" }, "sold", -1))
            ])
          ])
        ])
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})